import { type ColDef, type IRowNode } from "ag-grid-community"

import { ProductTableColumn } from "~/utils/productTableUtils"
import { sortSizesComparator } from "~/utils/sizeSplit"

import { SkuCellRenderer } from "../ProductCellRenderers"
import { productColumnNaming } from "./columnUtils"

type SkuRow = { size?: string }

/** The pinned SKU column (sorted by size) and the hidden size field every SKU detail grid leads with. */
export const skuIdentityColumnDefs = (): ColDef[] => [
  {
    headerName: productColumnNaming[ProductTableColumn.SKU].columnTitle,
    field: "skuId",
    pinned: "left",
    cellRenderer: SkuCellRenderer,
    sort: "asc",
    sortingOrder: ["asc", "desc"],
    width: 300,
    comparator: (_a: unknown, _b: unknown, nodeA: IRowNode<SkuRow>, nodeB: IRowNode<SkuRow>) => {
      const sizeA = nodeA?.data?.size
      const sizeB = nodeB?.data?.size
      if (!sizeA || !sizeB) return 0
      return sortSizesComparator(sizeA, sizeB)
    },
  },
  { field: "size", hide: true }, // read by SkuCellRenderer
]
